module.exports = __webpack_public_path__ + "static/media/message_board_system_p.86efcb78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/message_board_system_p.jpg
// module id = 365
// module chunks = 0